"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeImpex_de_de = void 0;
function backofficeImpex_de_de() {
    return {
        "backoffice.impex.export.navigationtitle": "Daten Export",
        "backoffice.impex.export.success.title": "Export erfolgreich gestartet",
        "backoffice.impex.export.success.message": "Ihr angeforderter Datenexport wurde im Hintergrund gestartet! Sie können das Backoffice wie gewohnt weiter verwenden. Sobald der Export fertig ist, erhalten Sie eine E-Mail mit einem Link auf den erstellten Export.",
        "backoffice.impex.export.success.gototaskbtn": "Gehe zu \"Aufgaben\""
    };
}
exports.backofficeImpex_de_de = backofficeImpex_de_de;
